import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import http from 'src/helper/http'
import { setTabBar, jumpToUser } from 'src/helper/webviewFun.js'
import Toast from '../../../component/Toast'
import { DatetimePicker } from 'react-vant/es/datetime-picker/index.js'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
@inject('store')
@observer
export default class extends Component {
  state = {
    codeValue: '',
    postsecList: [],
    recodList: [],
    lang: langM.en,
    language: 'en',
    inCbCf: false,
    listRootHeight: 10,
    showDatePick: false,
    showInco: 0,
    startOrEnd: 0, // 开始、结束
    inMoths: 7,
    inyear: 2024,
    inDay: 1,
    dateTime: '2024-05-01',
    endTime: '2024-7-10',
    sserse: '2024-04-01',
    toastContent: '',
    pkyear: 2024,
    pkmonmth: 6,
    pkday: 1,
    dataList: [],
  }

  async componentWillMount() {
    try {
      setTabBar('2')
    } catch (error) {}
    let { language } = this.props.location.query
    language = await getlang(language)

    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid,
    })

    if (language == 'tr') {
      setDocumentTitle('Üye Altın Aldı')
    } else if (language == 'en') {
      setDocumentTitle('Member received coins')
    } else if (language == 'ar') {
      setDocumentTitle('الكونزات التي حصل عليها الأعضاء')
    } else {
      setDocumentTitle('Member received coins')
    }
    this.getNowFormatDate()
  }

  componentDidMount() {
    let a = document.querySelector('.top-roots')
    let b = document.querySelector('.in-root')
    let e = document.querySelector('.tiem-select-root')
    let c =
      ((window.screen.height - a.clientHeight - e.clientHeight - b.clientHeight - 35 - 44) * 2) /
      100
    this.setState({ listRootHeight: c })
    this.dateTime = this.state.dateTime
  }
  clsoeModal = () => {
    this.setState({ showInco: 0 })
  }
  showPick = (e) => {
    this.setState({ showInco: 2 })
  }
  setTimeWhat = (e) => {
    let { endTime, dateTime } = this.state
    let b = e == 0 ? dateTime.split('-') : endTime.split('-')
    this.setState({ startOrEnd: e })
    console.log(b)
    if (e == 0) {
      this.setState({ pkyear: b[0] * 1, pkmonmth: b[1] - 1, pkday: b[2] * 1 })
    } else if (e == 1) {
      this.setState({ pkyear: b[0] * 1, pkmonmth: b[1] - 1, pkday: b[2] * 1 })
    }
  }

  monthpicker = async (date) => {
    let { startOrEnd } = this.state
    this.timeId && clearTimeout(this.timeId)
    let datetime = new Date(date)
    let year = datetime.getFullYear()
    let month = datetime.getMonth() + 1
    let day = datetime.getDate()
    let time =
      year + '-' + (month >= 10 ? month : `0${month}`) + '-' + (day >= 10 ? day : `0${day}`)
    this.timeId = setTimeout(() => {
      this.setState({
        pkday: day,
        pkmonmth: month - 1,
        pkyear: year,
        [startOrEnd == 1 ? 'endTime' : 'dateTime']: time,
      })
    }, 100)
  }

  timeId = null
  getNowFormatDate = async () => {
    let date = new Date(),
      year = date.getFullYear(), // 获取完整的年份(4位)
      month = date.getMonth() + 1 // 获取当前月份(0-11,0代表1月)
    let day = date.getDate()
    if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
    if (day < 10) day = `0${day}`
    let end = `${year}-${month}-${day}`
    let data = `${year}-${month}-01`
    await this.setState({ inMoths: month, inyear: year, inDay: day, endTime: end, dateTime: data })
    this.getDataList()
  }

  getDataList = async () => {
    let { dateTime, endTime } = this.state
    let res = await http.post('web/guild/member/coins', {
      scroll: '',
      start_date: dateTime,
      end_date: endTime,
    })
    if (res.code == 0) {
      let { list, scroll } = res.data
      this.setState({ dataList: list, hasMore: res.data.has_more, scroll })
    }
  }

  handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target
    let { hasMore } = this.state
    if (scrollTop + clientHeight + 30 >= scrollHeight) {
      if (hasMore) return this.addRankingList()
    }
  }

  addRankingList = async () => {
    let { dateTime, endTime, scroll, dataList } = this.state
    let res = await http.post('web/guild/member/coins', {
      scroll: scroll,
      start_date: dateTime,
      end_date: endTime,
    })
    if (res.code == 0) {
      let { list, scroll } = res.data
      this.setState({ dataList: [...dataList, ...list], hasMore: res.data.has_more, scroll })
    }
  }

  getLvBg = (e) => {
    let srt = ''
    if (e == 0) {
      srt = '0'
    } else if (e > 0 && e <= 9) {
      srt = '09'
    } else if (e > 9 && e <= 19) {
      srt = '1019'
    } else if (e > 19 && e <= 29) {
      srt = '2029'
    } else if (e > 29 && e <= 39) {
      srt = '3039'
    } else if (e > 39 && e <= 49) {
      srt = '4049'
    } else if (e > 49 && e <= 59) {
      srt = '5059'
    } else if (e > 59 && e <= 69) {
      srt = '6069'
    } else if (e > 69 && e <= 79) {
      srt = '7079'
    } else if (e > 79 && e <= 89) {
      srt = '8089'
    } else if (e > 89 && e <= 99) {
      srt = '9099'
    } else if (e == 100) {
      srt = '100'
    }
    return srt
  }

  confirmFn = () => {
    let { endTime, dateTime, lang } = this.state

    if (new Date(dateTime).getTime() > new Date(endTime).getTime()) {
      this.setState({ toastContent: lang.time_filter_toast1 })
      return this.refs.toast.hideRule(true)
    }

    this.setState({ showInco: 0 })
    this.getDataList()
  }

  _setScore = (score) => {
    score = parseInt(score || 0)
    if (score > 1000000) {
      score = parseInt(score / 100000) / 10 + 'M'
    } else if (score >= 1000) {
      score = parseInt(score / 100) / 10 + 'K'
    }
    return score
  }

  cbFn = async () => {
    await localstorage.set('cb', 1)
    history.goBack()
  }
  render() {
    let {
      dataList,
      pkday,
      pkmonmth,
      pkyear,
      toastContent,
      lang,
      language,
      endTime,
      dateTime,
      inDay,
      inMoths,
      inyear,
      startOrEnd,
      showInco,
      inCbCf,
      listRootHeight,
      sserse,
    } = this.state
    return (
      <div className={`hobiMemberCoins ${isRtl(language) ? 'in-ar' : ''}`}>
        <div className="flexd-top">
          <div className="" style={{ width: '7.5rem', height: '0.88rem' }}></div>
          <div className="close-web-view">
            <img
              className="close-img-icon"
              style={{ transform: `rotate(${isRtl(language) ? '180' : '0'}deg)` }}
              onClick={() => this.cbFn()}
              src="/img/app/ruby-agent/close-icon.png"
            />
            <div className="name-text">{lang.navTexg}</div>
            <img
              className="close-img-icon"
              style={{ opacity: 0 }}
              onClick={() => {}}
              src="/img/app/ruby-agent/recolde-detail.png"
            />
          </div>
        </div>
        <div
          className="top-roots"
          style={{ width: '7.5rem', height: '1.76rem', margin: '0 auto' }}
        ></div>
        <div className="in-root"></div>
        <div className="tiem-select-root">
          <div className="inleft">
            <img className="in-icon" src="/img/app/newhost/time-icon.png"></img>
            <div className="in-time-text">{lang.timeText}</div>
          </div>
          <div className="inright">
            <div className="start-time" onClick={() => this.showPick(1)}>
              <div className="start-time-text">{dateTime}</div>
              <img className="clis-img" src="/img/app/newhost/time_small.png"></img>
            </div>
            <div className="to">-</div>
            <div className="end-time" onClick={() => this.showPick(2)}>
              <div className="start-time-text">{endTime}</div>
              <img className="clis-img" src="/img/app/newhost/time_small.png"></img>
            </div>
          </div>
        </div>
        <div
          className="list-root-giftcodeview"
          onScroll={(e) => this.handleScroll(e)}
          style={{ height: `${listRootHeight}rem` }}
        >
          <div className="item-root">
            {dataList.length > 0 &&
              dataList.map((item, index) => (
                <div className="record-list" key={index}>
                  <div className="inLeft">
                    <div className="rankindex">{index + 1}</div>
                    <img
                      className="item-atv"
                      src={item.UserInfo.avatarurl}
                      onClick={() => jumpToUser(item.uid)}
                    ></img>
                    <div className="item-info">
                      <div className="name-madal">
                        <div className="name-text">{item.UserInfo.nickname}</div>
                        {item.UserInfo.gender > 0 && (
                          <img
                            className="sex-man"
                            src={
                              item.UserInfo.gender == 2
                                ? '/img/app/newhost/woman_icon.png'
                                : '/img/app/newhost/boy_icon.png'
                            }
                          />
                        )}
                        <img src={item.UserInfo.countryIcon} className="user-ctry-icon"></img>
                      </div>
                      <div className="id-num">ID: {item.UserInfo.duid}</div>
                    </div>
                  </div>
                  <div className="inRight">
                    <img className="gold-icon" src="/img/app/newhost/new_gold.png"></img>
                    <div className="gold-num">{this._setScore(item.coin / 100)}</div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        {showInco > 0 && (
          <div
            className="show-modal"
            onClick={(e) => {
              e.stopPropagation()
              this.setState({ showInco: 0 })
            }}
          >
            {showInco == 2 && (
              <div
                className="time-selectpick"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                <div className="title-root">
                  <div className="inthe-text">{lang.time_filter}</div>
                  <div className="conf-root" onClick={this.confirmFn}>
                    {lang.confirm}
                  </div>
                </div>
                <div className="date-picker-root">
                  <DatetimePicker
                    showToolbar={false}
                    type="date"
                    key={996}
                    columnsOrder={['year', 'month', 'day']}
                    minDate={new Date(2024, 4, 1)}
                    maxDate={new Date(inyear, inMoths - 1, inDay)}
                    itemHeight={'0.88rem'}
                    value={new Date(pkyear, pkmonmth, pkday)}
                    onChange={this.monthpicker}
                    columnsTop={
                      <div className="inthe-time-select">
                        <div
                          className={`select-num ${startOrEnd == 0 ? 'inset' : ''}`}
                          onClick={() => this.setTimeWhat(0)}
                        >
                          {dateTime}
                        </div>
                        <div className="del-icon">-</div>
                        <div
                          className={`select-num ${startOrEnd == 1 ? 'inset' : ''}`}
                          onClick={() => this.setTimeWhat(1)}
                        >
                          {endTime}
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            )}
          </div>
        )}
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/hobiMemberCoins/index.js